<div *ngIf="showLoader" class="loader-wrapper">
    <img src="../assets/vectors/HELPDESK LOADER.svg" alt="Loader Icon">
       <div class="progress-bar-container">
        <div class="progress-bar" [class.quick-complete]="quickComplete"></div>
    </div>
    <div class="loading-text">Help Desk</div>
</div>

<div *ngIf="path === 'Help Desk' && isSessionOngoing && !showLoader">
    <app-help-desk (openTicketDetailsEvent)="openTicket($event)"></app-help-desk>
</div>
<div *ngIf="path === 'Ticket Details' && isSessionOngoing && !showLoader">
    <app-ticket-details (navigateEvent)="navigate($event)" [ticketDetails]="ticketDetails" [ccList]="ticketDetails.cc_list"></app-ticket-details>
</div>